// extracted by mini-css-extract-plugin
export default {"CityAndPrice":"CityAndPrice_CityAndPrice__So2NH","city":"CityAndPrice_city__vwGe4","price":"CityAndPrice_price__IpXrH"};